var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page page--terms terms"},[_c('h1',{attrs:{"id":"terms"}},[_vm._v(_vm._s(_vm.$t('pricing.title')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('pricing.text'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }